<template>
  <div
    class="product-variant-slide"
    @click.prevent="onSelect"
    @keydown.enter="onSelect"
    @keydown.space.prevent="onSelect"
  >
    <div class="pvs-title">
      {{ data.label }}
    </div>

    <div class="pvs-container-inner">
      <fn-product-pricing
        :badges="data.badges"
        :pricing="data.pricing"
        :stock-level-status="data.stockLevelStatus"
        product-variant
      />

      <div
        v-if="!!notInStockErrorI18n"
        class="pvs-availability"
      >
        {{ $t(notInStockErrorI18n) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineComponent({
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    notInStockErrorI18n: {
      type: String,
      default: null,
    },
  },
  emits: ['input'],
  methods: {
    onSelect() {
      // Prevent selection if the variant is out of stock
      if (this.notInStockErrorI18n) {
        return;
      }

      this.$emit('input', this.data.url);
    },
  },
});
</script>

<style lang="scss" scoped>
.product-variant-slide {
  @include subgrid-inherit();
  padding: $pad;

  .pvs-container-inner {
    @include subgrid-inherit();
  }
}

.pvs-title {
  font-size: map-get($font-sizes, 'lxl');
  font-weight: map-get($font-weights, 'bold');
  line-height: 140%;
  letter-spacing: -0.02em;
  color: $color-general-text-neutral-default;
  margin-bottom: $pad;
}

.pvs-availability {
  font-size: map-get($font-sizes, 'm');
  font-weight: map-get($font-weights, 'bold');
  line-height: map-get($font-line-heights, 'xxxs');
  color: $color-general-text-neutral-default;
  margin-top: $pad;
}

.pvs-price-badge {
  display: inline;
  background: $color-general-background-loyalty-friends-secondary-default;
}
</style>
